import React from 'react';
import './teams.scss';
import { observer } from 'mobx-react-lite';
import { CheckboxInputControlled, RadioGroupInput, ToggleInput, ToggleLayout } from '../input';
import { GenerativeAiFormState } from './generativeAiFormState';
import { GenerativeAiProvider } from '@clipr/lib';

type PublicTeamFormProps = {
  model: GenerativeAiFormState;
  disabled: boolean;
};

export const GenerativeAiForm = observer(({ model, disabled }: PublicTeamFormProps) => {
  return <div className="scrollable generative-ai-container">
    <RadioGroupInput
      label='AI provider'
      onChange={(_evt: React.SyntheticEvent, value: string) => model.changeAiProvider(value)}
      value={model.generativeAiProvider as string}
      name={'generativeAiProvider'}
      items={[
        { value: GenerativeAiProvider.Amazon, label: 'AWS Bedrock' },
        { value: GenerativeAiProvider.OpenAi, label: 'OpenAI', disabled }]} 
      />

    <ToggleInput
      className="medium"
      disabled={!model.generativeAiProvider}
      label='AI video summary'
      toggled={!!model?.team?.summarizationEnabled}
      toggleLayout={ToggleLayout.Buttons}
      toggledLabel='Enabled'
      notToggledLabel='Disabled'
      name={'cliprGptSummary'}
      onChange={() => model.toggleSummarization()}
    />

    <ToggleInput
      className="medium clipr-gpt-toggle"
      disabled={!model.generativeAiProvider}
      label='CLIPr GPT'
      toggled={!!model?.team?.cliprGptEnabled}
      toggleLayout={ToggleLayout.Buttons}
      toggledLabel='Enabled'
      notToggledLabel='Disabled'
      name={'cliprGpt'}
      onChange={() => model.toggleCliprGpt()}
    />
    
    <ToggleInput
      className="medium clipr-gpt-action-items-toggle"
      disabled={!model.generativeAiProvider}
      label='AI action items'
      toggled={!!model?.team?.actionItemsExtractionEnabled}
      toggleLayout={ToggleLayout.Buttons}
      toggledLabel='Enabled'
      notToggledLabel='Disabled'
      name={'cliprGptActionItems'}
      onChange={() => model.toggleActionItems()}
    />

    <div>
    <CheckboxInputControlled
      name="email-notifications"
      label="Enable email notifications for all members"
      className="email-notifications-checkbox"
      disabled={!model.generativeAiProvider}
      model={model.cliprGptEmailNotifications}
    />
    <p className="clipr-gpt-info">* only for meetings and mobile video types</p>
    </div>
  </div>
});
